class CartRemoveButton extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('click', (event) => {
			event.preventDefault();
			const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
			cartItems.updateQuantity(this.closest('.cart-item'), this.dataset.index, 0);
		});
	}
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
	constructor() {
		super();

		this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

		this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
			.reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

		this.debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, 300);

		this.addEventListener('change', this.debouncedOnChange.bind(this));
	}

  
	onChange(event) {
		var quantityContainer = event.target.closest('.cart-item__quantity-wrapper');
		var quantity = quantityContainer.querySelector('input').value;
		if(quantityContainer.querySelector('.susbcription-options') == null) {
			selling_plan = null;
		} else {
			var selling_plan = quantityContainer.querySelector('.susbcription-options').value;
		}
		if(selling_plan == 0 || selling_plan == 'One-Time Only' ) {
			selling_plan = null;
		}
		var quantitySelector = false;
		if(event.target.dataset.quantity == 'true') {
			quantitySelector = true;
		}
		this.updateQuantity(event.target.closest('.cart-item'), event.target.dataset.index, quantity, document.activeElement.getAttribute('name'), selling_plan, quantitySelector);
	}

	getSectionsToRender() {
		return [
			{
				id: 'main-cart-items',
				section: document.getElementById('main-cart-items').dataset.id,
				selector: '.js-contents',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section'
			},
			{
				id: 'cart-live-region-text',
				section: 'cart-live-region-text',
				selector: '.shopify-section'
			},
			{
				id: 'main-cart-footer',
				section: document.getElementById('main-cart-footer').dataset.id,
				selector: '.js-contents',
			}
		];
	}

	updateQuantity(el, line, quantity, name, selling_plan, quantitySelector) {
		this.enableLoading(line);

		const body = JSON.stringify({
			line,
			quantity,
			selling_plan,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname
		});

		fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
			.then((response) => {
				return response.text();
			})
			.then((state) => {        
				const parsedState = JSON.parse(state);
				this.classList.toggle('is-empty', parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector('cart-drawer');
				const cartFooter = document.getElementById('main-cart-footer');

				if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
				if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

				this.getSectionsToRender().forEach((section => {
					const elementToReplace =
						document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
					elementToReplace.innerHTML =
						this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
				}));

				this.updateLiveRegions(line, parsedState.item_count, quantitySelector);
				const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
				} else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
					trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
				}
				this.disableLoading();
				this.manageGWP(parsedState.item_count, parsedState.total_price, el.dataset.gwpId);

				if(window.ensureCartBundleValidity){
					window.ensureCartBundleValidity()
				}
              
				if(window.autoAddEligibleItems){
					window.autoAddEligibleItems()
				}

               if(window.handleFreeGifts){
					window.handleFreeGifts();
				}
				if(window.smoothAccordionState) {
					setTimeout(() => { 
						window.smoothAccordionState.update()
					},450);
				}
			}).catch(() => {
				this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
				const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
				errors.textContent = window.cartStrings.error;
				this.disableLoading();
			});
}

	updateLiveRegions(line, itemCount, quantity) {
		if (this.currentItemCount === itemCount && quantity) {
			const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
			const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

			lineItemError
				.querySelector('.cart-item__error-text')
				.innerHTML = window.cartStrings.quantityError.replace(
					'[quantity]',
					quantityElement.value
				);
		}

		this.currentItemCount = itemCount;
		this.lineItemStatusElement.setAttribute('aria-hidden', true);

		const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
		cartStatus.setAttribute('aria-hidden', false);

		setTimeout(() => {
			cartStatus.setAttribute('aria-hidden', true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.add('cart__items--disabled');

		const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
		const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute('aria-hidden', false);
	}

	disableLoading() {
		const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
		mainCartItems.classList.remove('cart__items--disabled');
	}

	manageGWP(quantity, total_price, gwp_id) {
		// check and capture free gift if it is in the cart
		let gwpProduct = document.querySelector('.cart-item[data-gwp="true"]');
		if (gwpProduct === undefined || gwpProduct === null) return;
		if(window.gwp.type === "subtotal") {
			if(total_price < window.gwp.subtotal_threshold) {
				gwpProduct.querySelector('cart-remove-button').click();
			}
		} else if(window.gwp.type === "quantity") {
			if(quantity <= window.gwp.quantity_threshold) {
				gwpProduct.querySelector('cart-remove-button').click();
			}
		} else if(window.gwp.type === "buy_x_get_y") {
			if(document.querySelectorAll('.cart-item[data-gwp-id="'+ gwp_id +'"]').length < 2){
				document.querySelector('.cart-item[data-gwp][data-gwp-id="'+ gwp_id +'"] cart-remove-button').click();
			}
		}
	}
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
	customElements.define('cart-note', class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	});
};

window.ensureCartBundleValidity = function(){
		fetch(routes.cart_url + '.json').then(res => res.json()).then(cart => {
			const bundle_master_products = {}
			const bundle_child_products = {}
			const updates = {}

			cart.items.forEach(line_item => {
				if(line_item.properties && line_item.properties["_byb"]){
					const key = line_item.properties["_byb"] + '__' + line_item.properties["_timestamp"]
					const children = {}
					const children_count = line_item.properties["_child-ids-byb"].length
					
					line_item.properties["_child-ids-byb"].forEach(id => {
						children[id] = children[id] ? children[id] : 0;
						children[id] += line_item.quantity
					})
					
					bundle_master_products[key] = bundle_master_products[key] ? bundle_master_products[key] : {}
					bundle_master_products[key] = {
							"total_children" : children_count,
							"children" : children,
							"timestamp" : line_item.properties["_timestamp"],
						}
				}
				else if(line_item.properties && line_item.properties["_byb-master"]){
					const key = line_item.properties["_byb-master"] + '__' + line_item.properties["_timestamp"]
					
					bundle_child_products[key] = bundle_child_products[key] ? bundle_child_products[key] : {
						'total' : 0,
						'products' : {},
                        "require_parent": line_item.properties["_byb-type"] !== "set"
					}
					
					bundle_child_products[key]['total'] += line_item.quantity;
					bundle_child_products[key]['products'][line_item.key] = line_item.quantity
                    bundle_child_products[key]["require_parent"] = line_item.properties["_byb-type"] !== "set"
				}
			})

			if(Object.keys(bundle_child_products).length){
				Object.keys(bundle_child_products).forEach(bundle_key => {
                  if(bundle_child_products[bundle_key]["require_parent"]){
                    Object.keys(bundle_child_products[bundle_key]['products']).forEach(line_key => {
    					if(! bundle_master_products[bundle_key]){
    						updates[line_key] = 0
    					}
    				})
                  }
			});
			}

				if(Object.keys(updates).length){

					const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
					const sections = cart_holder.getSectionsToRender().map((section) => section.id);
					const sections_url = window.location.pathname + (window.location.search || '')
					fetch(window.Shopify.routes.root + 'cart/update.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({ updates, sections, sections_url })
					})
					.then(response => {
						return response.json();
					}).then(cart => {

						if(cart_holder && cart.items.length === 0 && ! cart_holder.classList.contains('is-empty')){ cart_holder.classList.add('is-empty');}
						cart_holder.renderContents(cart);
					})
					.catch((error) => {
						console.error('Error:', error);
					});
				}
		});

	
}

window.handleFreeGifts  = function() {
    console.log("handleFreeGifts")
    let hasEligibleItem = document.querySelector('cart-drawer-items').dataset.hasEligibleItem === 'true';
    let freeProduct = parseInt(document.querySelector('cart-drawer-items').dataset.freeProduct, 10) || 0;
    let freeProductAvailable = document.querySelector('cart-drawer-items').dataset.freeProductAvailable === 'true';
    let freeProducts = parseInt(document.querySelector('cart-drawer-items').dataset.freeProducts);
    let needToAdd = hasEligibleItem && !freeProducts;
    let dontProcess = (!hasEligibleItem && !freeProducts) || (hasEligibleItem && freeProducts);
   if(dontProcess){
     return;
   }
    if(freeProduct && freeProductAvailable) {
    let updates = {};
    updates[freeProduct] = hasEligibleItem ? 1: 0;
    
    const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const sections = cart_holder.getSectionsToRender().map((section) => section.id);
    const sections_url = window.location.pathname + (window.location.search || '')
    fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
    'Content-Type': 'application/json'
    },
    body: JSON.stringify({ updates, sections, sections_url })
    })
    .then(response => {
    return response.json();
    }).then(cart => {
    
    if(cart_holder && cart.items.length === 0 && ! cart_holder.classList.contains('is-empty')){ cart_holder.classList.add('is-empty');}
    cart_holder.renderContents(cart);
    })
    .catch((error) => {
    console.error('Error:', error);
    });
    }
    }              

window.autoAddEligibleItems = function(){
  if(document.querySelector('input.auto-add-item')){
    document.querySelector('input.auto-add-item').closest('form')?.querySelector('[type="submit"]')?.click()
  }

  window.removeIneligibleItems()
}

window.removeIneligibleItems = function(){
  fetch(routes.cart_url + '.json').then(res => res.json()).then(cart => {
    const updates = {};

	// Get free product blocks with exception configurations
	const freeProductBlocksWithConfig = window.__sectionSettings?.['cart-drawer']?.blocks?.filter(
	block => block.type === 'free-product' 
		&& Array.isArray(block?.settings?.except_when_cart_has_products_in) 
		&& block.settings.except_when_cart_has_products_in.length > 0
	) ?? [];

	// Build lookup maps
	const productHandlesInCart = new Set(cart.items.map(item => item.handle));
	const cartItemRemoveWhen = {};

	// Build removal conditions map
	if (freeProductBlocksWithConfig?.length > 0) {
		freeProductBlocksWithConfig.forEach(block => {
		const freeProductHandle = block.settings.free_product;
		
		if (productHandlesInCart.has(freeProductHandle)) {
			cartItemRemoveWhen[freeProductHandle] = block.settings.except_when_cart_has_products_in
			.map(product => product.handle);
		}
		});
	}

	// Identify and mark removable items
	cart.items.forEach(item => {
		const shouldRemove = 
			// Remove if it's a paid GWP item
			(item?.properties?._gwp === "0" && item.final_line_price > 0) ||
			// Remove if cart contains exception products
			(cartItemRemoveWhen[item.handle]?.some(handle => productHandlesInCart.has(handle)));
		
		if (shouldRemove) {
			updates[item.key] = 0;
		}
	});
    
    if(updates && Object.keys(updates).length > 0){
      const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const sections = cart_holder.getSectionsToRender().map((section) => section.id);
      const sections_url = window.location.pathname + (window.location.search || '')
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates, sections, sections_url })
      }).then(response => {
        return response.json();
      }).then(cart => {
        if(cart_holder && cart.items.length === 0 && ! cart_holder.classList.contains('is-empty')){ cart_holder.classList.add('is-empty');}
          cart_holder.renderContents(cart);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  });
}
/*           
window.autoAddEligibleItems = function(){
  console.log("window.autoAddEligibleItems")
  const cart_holder = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if(cart_holder && cart_holder.getSectionsToRender){
    if(document.querySelector('input.auto-add-item')){
      document.querySelector('input.auto-add-item').closest('form')?.querySelector('[type="submit"]')?.click()
    }else if(window.getCookieValue && window.getCookieValue('discount_code') === 'MIAMITOTE' && document.querySelector('.cart-drawer__collection.free_product_block form [type="submit"]')){
      document.querySelector('.cart-drawer__collection.free_product_block form [type="submit"]')?.click()
    }

    if(document.querySelector('.remove-free-gift')){
      document.querySelector('.remove-free-gift').click()
    }
  }else{
    setTimeout(function(){
      window.autoAddEligibleItems();
    }, 1000)
  }
}*/

window.autoAddEligibleItems();